import { AbstractObjectRegistry } from "@mcleod/core";
import { AllowedUseAddlOption } from "./AllowedUseAddlOption";

export class AllowedUseAddlOptionRegistry extends AbstractObjectRegistry<AllowedUseAddlOption> {
    private static registry: AllowedUseAddlOptionRegistry;

    public static get(): AllowedUseAddlOptionRegistry {
        this.initialize();
        return this.registry;
    }

    private static initialize() {
        if (this.registry == null) {
            this.registry = new AllowedUseAddlOptionRegistry();
        }
    }
}
